import React from 'react';
// import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const styles = theme => ({
  root: {},
});

const Icon = props => {
  const { classes, children, ...rest } = props;
  return <SvgIcon {...rest}>{children}</SvgIcon>;
};

export default withStyles(styles, { withTheme: true })(Icon);
